module.exports = __webpack_public_path__ + "static/media/st-arrow-down.1105da87.svg";